import { useEffect } from "react"

import { toast } from "@/components/toast"
import { sidebarAiChatApi } from "../threads/components/right-bar/ai-chat/sidebar-ai-chat-api"
import { useSidebarAiChatState } from "../threads/components/right-bar/ai-chat/sidebar-ai-chat-state"
import { abortActiveSidebarAiChatStream } from "../threads/components/right-bar/ai-chat/sidebar-ai-chat-sync"

/**
 * Opens a stored chat from the Agent sidebar: the embedded assistant mounts on
 * the chat's scope, then this swaps in that session's history, the same way the
 * panel's Recent chats menu does.
 */
export function useLoadChatSession(sessionId: string | null) {
	useEffect(() => {
		if (!sessionId) return
		if (useSidebarAiChatState.getState().sessionId === sessionId) return
		let cancelled = false
		void sidebarAiChatApi
			.loadHistory(sessionId)
			.then((messages) => {
				if (cancelled) return
				abortActiveSidebarAiChatStream()
				useSidebarAiChatState.getState().switchSession(sessionId, messages)
			})
			.catch(() => {
				if (!cancelled) toast.error({ title: "Couldn't open this chat" })
			})
		return () => {
			cancelled = true
		}
	}, [sessionId])
}
